export function friendlyError(err: unknown): string {
  if (err instanceof Error) {
    const msg = err.message.toLowerCase();
    if (msg.includes("quota exceeded") || msg.includes("429")) {
      return "Too many requests. Please wait a moment and try again.";
    }
    if (msg.includes("403") || msg.includes("forbidden")) {
      return "Access denied. You may need to sign in again.";
    }
    if (msg.includes("404") || msg.includes("not found")) {
      return "The requested data was not found.";
    }
    if (msg.includes("network") || msg.includes("fetch") || msg.includes("failed to fetch")) {
      return "Network error. Check your connection and try again.";
    }
    if (msg.includes("timeout")) {
      return "Request timed out. Please try again.";
    }
    return err.message;
  }
  return "An unexpected error occurred.";
}
